/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from 'zod/v4'

export const projectSchema = z.object({
  bookmarked: z.boolean().optional().default(false).describe('Indicates whether the project is bookmarked').meta({ examples: [false] }),
  description: z.string().max(250).nullish().describe('A short description of the project').meta({ examples: ['This is a project for a new building with multiple floors and rooms.'] }),
  name: z.string().describe('The name of the project').meta({ examples: ['New Building Project'] }),
  createdAt: z.iso.datetime().describe('The date and time when the project was created').meta({ examples: ['2026-09-09T12:34:56Z'] }),
  id: z.string().describe('Unique identifier').meta({ examples: [1] }),
  updatedAt: z.iso.datetime().describe('The date and time when the project was last updated').meta({ examples: ['2026-09-10T12:34:56Z'] }),
})
